
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconClickTransition } from '@shared/transitions/icon-click.transition';

@Component({
    selector: 'icon-bag',
    styleUrls: ['./icon-bag.component.scss'],
    animations: [IconClickTransition()],
    template: `
				@if (!showSpinner) {
				  <i class="fa-light fa-bag-shopping fa-lg"></i>
				}
				@if (showSpinner) {
				  <div class="rotating-icon">
				    <img src="/assets/icons/add-to-bag-spinner.svg" alt="Spinner Icon">
				  </div>
				}
				`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class IconBagComponent {
	@Input() showSpinner: boolean = false;
	@Input() clickCount: number;
}
